export const BackendFiltersUrlKey = 'filters';
